<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津市友谊宾馆有限公司</div>
                  <p class="p1">
                    天津市友谊宾馆坐落于市中心著名的南京路上，地处小白楼商业街和滨江道步行街的核心位置(南京路94号)，周边写字楼、银行、购物中心林立，所处的地理位置十分优越。
                  </p>
                  <p class="p2">
                    可乘坐公交车、地铁等多种交通工具到达;距地铁一号线营口道地铁站(市中心最大换乘站)步行只需五分钟;距滨江道步行街直线步行距离不超过5分钟;距天津市著名的五大道风景区近在咫尺。
                  </p>
                  <p class="p2">
                    友谊宾馆所处的地理位置周边各种服务业态十分齐全：方圆一公里内遍布君隆广场、国际大厦、CBD等高档写字楼;伊势丹、乐宾百货、国际商场等大型购物中心;金钱豹、海底捞、好乐迪、麦当劳、星巴克等餐饮、娱乐场所。友谊宾馆紧邻中国银行、中信银行，马路对面设有工商银行、农业银行、大华银行等金融服务机构。
                    客房简介
                    友谊宾馆共有舒适、洁净、设施完备的豪华客房共186间、套，可以满足您不同的需要。
                  </p>
                  <p class="p1">
                    房间由美国专业设计师设计，空间布局合理、硬件设施豪华，感觉舒适。单人间及标准间的面积达到40平米，套间面积68平方米。房间顶高3米。所有房间的卧具及软片均按照美国豪华酒店标准配备，卧床采用世界知名品牌“甜梦之床”，让您在劳累的工作之余尽享一夜酣睡。客房配备了高速宽带网、舒适写字台及卫星电视等设施。客房服务中心24小时为您提供贴心、快捷的服务，及时为您解决各种问题。
                  </p>
                  <p class="p1">
                    宴会
                    酒店一层拥有装修独具风格的友谊宴会厅，面积600平方米，独享无柱空间，可承接各种大中型宴会，及举办各种会议。
                    银河全日制餐厅及会所
                    承接零点、自助餐、酒会、外卖等服务，为您提供无与伦比的优质服务和丰盛的美食体验。所有会所均配备高档视听设备，装修典雅，量身打造所有细节，确保为您成功举办每场宴会及会议。
                  </p>
                  <div class="img1">
                    <img
                      src="@/assets/images/yybg1.png"
                      alt=""
                      height="450px"
                      width="600px"
                    />
                  </div>

                  <div class="img1">
                    <img
                      src="@/assets/images/yybg2.png"
                      alt=""
                      height="800px"
                      width="800px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>